<div class="form-group">
  <label [for]="name">{{ placeholder | titlecase }}</label>
  <select
    [disabled]="disabled"
    class="form-select"
    [(ngModel)]="model"
    [name]="name"
    (ngModelChange)="eventChange()"
    #errorModel="ngModel"
    [required]="required"
  >
    <option *ngIf="emptyChoice" [ngValue]="emptyModel"></option>
    <option
      *ngFor="let choice of choices | keyvalue"
      [ngValue]="keyOutputField ? choice.key : choice.value"
    >
      {{ choice.value }}
    </option>
  </select>
  <span
    class="text-danger"
    *ngIf="(model || myForm.submitted) && errorModel.errors?.required"
  >
    Il campo {{ placeholder | lowercase }} è obbligatorio
  </span>
</div>
